(() => {
  const selectors = document.querySelectorAll('[data-cl-selector]');

  selectors.forEach((root) => {
    const toggle = root.querySelector('[data-cl-toggle]');
    const dialog = root.querySelector('[data-cl-dialog]');
    const backdrop = root.querySelector('[data-cl-backdrop]');
    if (!toggle || !dialog) return;

    // The header is `position: fixed` with `transform`, which breaks
    // `position: fixed` for descendants (they anchor to the header, not the
    // viewport). Move the dialog + backdrop to document.body so the mobile
    // bottom-sheet anchors correctly to the viewport.
    if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
    if (backdrop && backdrop.parentElement !== document.body) document.body.appendChild(backdrop);

    const closers = dialog.querySelectorAll('[data-cl-close], [data-cl-sheet-handle]');

    const isDesktop = () => window.matchMedia('(min-width: 1440px)').matches;

    function positionForDesktop() {
      const rect = toggle.getBoundingClientRect();
      dialog.style.top = (rect.bottom + 14) + 'px';
      dialog.style.right = (window.innerWidth - rect.right) + 'px';
      dialog.style.left = 'auto';
      dialog.style.bottom = 'auto';
    }

    function clearInlinePosition() {
      dialog.style.top = '';
      dialog.style.right = '';
      dialog.style.left = '';
      dialog.style.bottom = '';
    }

    function open() {
      toggle.setAttribute('aria-expanded', 'true');
      if (isDesktop()) {
        positionForDesktop();
        dialog.classList.remove('3xl:opacity-0', '3xl:invisible');
        dialog.classList.add('3xl:opacity-100', '3xl:visible');
      } else {
        clearInlinePosition();
        dialog.classList.remove('translate-y-full');
        dialog.classList.add('translate-y-0');
        if (backdrop) {
          backdrop.classList.remove('opacity-0', 'invisible');
          backdrop.classList.add('opacity-100', 'visible');
        }
        document.body.style.overflow = 'hidden';
      }
    }

    function close() {
      toggle.setAttribute('aria-expanded', 'false');
      dialog.classList.add('3xl:opacity-0', '3xl:invisible');
      dialog.classList.remove('3xl:opacity-100', '3xl:visible');
      dialog.classList.add('translate-y-full');
      dialog.classList.remove('translate-y-0');
      if (backdrop) {
        backdrop.classList.add('opacity-0', 'invisible');
        backdrop.classList.remove('opacity-100', 'visible');
      }
      document.body.style.overflow = '';
      clearInlinePosition();
    }

    window.addEventListener('resize', () => {
      if (toggle.getAttribute('aria-expanded') === 'true' && isDesktop()) positionForDesktop();
    });

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      isOpen ? close() : open();
    });

    closers.forEach((el) => el.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    }));

    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (root.contains(e.target) || dialog.contains(e.target)) return;
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') close();
    });

    // Picking a language alone used to leave the country — and with it the
    // market, and with it the checkout's shipping country — on the previous
    // market: "Italiano" landed you on /it-de, an Italian storefront on the
    // German market, with "Germania" preselected at checkout. So pull the
    // country along for languages that map to exactly one market. The map is
    // built server-side and only contains unambiguous languages (it/fr/nl);
    // de and en are deliberately absent (see country-language-selector.liquid).
    let langCountryMap = {};
    try {
      langCountryMap = JSON.parse(dialog.dataset.clLangCountryMap || '{}');
    } catch (_) {
      // Malformed map: fall back to the old independent behaviour.
    }

    // Once the visitor picks a country themselves, stop second-guessing them —
    // a German speaker shopping to Italy is a legitimate combination.
    let countryTouched = false;
    dialog.addEventListener('click', (e) => {
      const row = e.target.closest?.('[data-cl-row]');
      if (row?.querySelector('input[name="country_code"]')) countryTouched = true;
    });

    function syncCountryToLanguage(localeCode) {
      if (countryTouched) return;
      const iso = langCountryMap[localeCode.split('-')[0].toLowerCase()];
      if (!iso) return;
      const target = dialog.querySelector(`input[name="country_code"][value="${iso}"]`);
      if (!target || target.checked) return;
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      // The country list scrolls, so make the change visible rather than
      // silently rewriting a selection the visitor cannot see.
      target.closest('[data-cl-row]')?.scrollIntoView({ block: 'nearest' });
    }

    dialog.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const name = radio.name;
        dialog.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((sib) => {
          sib.closest('[data-cl-row]')?.classList.toggle('is-selected', sib.checked);
        });
        if (name === 'locale_code' && radio.checked) syncCountryToLanguage(radio.value);
      });
    });

    dialog.querySelectorAll('[data-cl-row]').forEach((row) => {
      row.addEventListener('click', (e) => {
        if (e.target.tagName === 'INPUT') return;
        const radio = row.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
})();
